// The Leasing Activity Report was authored against an 11in-wide iframe.
// At 96 CSS pixels per inch, a Letter-landscape layout viewport is 1056x816.
// Keep that viewport fixed and transform only the iframe element: changing the
// iframe's CSS width reflows headings and initializes report charts differently.
const REPORT_WIDTH = 1056
const REPORT_HEIGHT = 816

export const ReportPreviewScale = {
  mounted() {
    this.stage = this.el.querySelector("[data-report-stage]")
    this.frame = this.el.querySelector("[data-report-frame]")

    this.resizeObserver = new ResizeObserver(([entry]) => {
      this.fitReport(entry.contentRect)
    })

    this.resizeObserver.observe(this.el)
  },

  updated() {
    this.stage = this.el.querySelector("[data-report-stage]")
    this.frame = this.el.querySelector("[data-report-frame]")

    const style = getComputedStyle(this.el)
    const width =
      this.el.clientWidth -
      Number.parseFloat(style.paddingLeft) -
      Number.parseFloat(style.paddingRight)
    const height =
      this.el.clientHeight -
      Number.parseFloat(style.paddingTop) -
      Number.parseFloat(style.paddingBottom)

    this.fitReport({ width, height })
  },

  destroyed() {
    this.resizeObserver?.disconnect()
  },

  fitReport({ width, height }) {
    if (!this.stage || !this.frame) return

    const scale = Math.max(
      0,
      Math.min(1, width / REPORT_WIDTH, height / REPORT_HEIGHT),
    )

    this.stage.style.width = `${REPORT_WIDTH * scale}px`
    this.stage.style.height = `${REPORT_HEIGHT * scale}px`
    this.frame.style.transform = `scale(${scale})`
  },
}
